<svelte:options customElement={{
  tag: 'content-width',
  shadow: 'none',
  props: {
    variant: { reflect: true, type: 'String' }
  }
}} />

<script>
  import { onMount } from 'svelte';
  /**
   * コンテンツ幅設定
   * パーツライブラリ準拠の mod-auto 構造
   * @prop {string} variant - 幅種別:
   *   'default' (mod-auto 1280px), 'full' (mod-auto-full 全幅),
   *   'spFull' (mod-auto-spFull SP時全幅)
   */
  export let variant = 'default';

  const classMap = {
    default: 'mod-auto',
    '960': 'mod-auto_960',
    full: 'mod-auto-full',
    spFull: 'mod-auto-spFull'
  };

  $: className = classMap[variant] || 'mod-auto';

  let wrapperEl;

  onMount(() => {
    const host = wrapperEl.parentElement;
    const nodesToMove = [];
    host.childNodes.forEach(node => {
      if (node !== wrapperEl) nodesToMove.push(node);
    });
    nodesToMove.forEach(node => wrapperEl.appendChild(node));
  });
</script>

<div class={className} bind:this={wrapperEl}></div>
